/* Capsalia landing page behaviour. Mirrors the interactions on resilia.shop/products/oregano-skio:
   drawers, countdown, gallery + thumbs, video strip, offer selection, add to cart, accordions,
   stat counters, journey timeline, flip cards, sliders, read-more reviews. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) { return '$' + (cents / 100).toFixed(2); };

  /* ---------- drawers ---------- */
  var overlay = $('[data-cl-overlay]');
  function openDrawer(id) { var d = document.getElementById(id); if (!d) return; d.classList.add('drawer--is-open'); overlay && overlay.classList.add('is-visible'); document.body.style.overflow = 'hidden'; }
  function closeDrawers() { $$('.drawer--is-open').forEach(function (d) { d.classList.remove('drawer--is-open'); }); overlay && overlay.classList.remove('is-visible'); document.body.style.overflow = ''; }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[aria-controls], .js-drawer-close, [data-cl-overlay]');
    if (!t) return;
    if (t.classList.contains('js-drawer-close') || t.hasAttribute('data-cl-overlay')) { closeDrawers(); return; }
    var id = t.getAttribute('aria-controls');
    if (id === 'NavDrawer' || id === 'CartDrawer') { e.preventDefault(); if (id === 'CartDrawer') refreshCart(); openDrawer(id); }
  });

  /* ---------- cart drawer (Metabolae's "Your order" drawer, Leo 2026-10-27) ---------- */
  var cdrVariants = {}; try { cdrVariants = JSON.parse(($('#cdr-variants') || {}).textContent || '{}'); } catch (e) {}
  var cdrBulletsTpl = $('#cdr-bullets');
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  function renderCart(cart) {
    var drawer = $('#CartDrawer'); var list = $('[data-cart-items]'); var bubble = $$('.cart-link__bubble');
    bubble.forEach(function (b) { b.textContent = cart.item_count; b.classList.toggle('cart-link__bubble--visible', cart.item_count > 0); });
    if (!list || !drawer) return;
    drawer.classList.toggle('cdr--empty', !cart.items.length);
    drawer.classList.remove('cdr--busy');
    var compareTotal = 0;
    list.innerHTML = cart.items.map(function (it, i) {
      var v = cdrVariants[String(it.variant_id)] || {}; var bags = v.bags || 1;
      var compareUnit = Math.max((it.selling_plan_allocation && it.selling_plan_allocation.compare_at_price) || 0, v.compare || 0, it.final_price); /* same anchor as the page's offer boxes */
      compareTotal += compareUnit * it.quantity;
      var meta = [it.variant_title, it.selling_plan_allocation ? it.selling_plan_allocation.selling_plan.name : ''].filter(Boolean).join(' · ');
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_300x$1$2') : '';
      return '<div class="cdr__item" data-line="' + (i + 1) + '">' +
        '<img class="cdr__thumb" src="' + img + '" alt="" width="120" height="120">' +
        '<div class="cdr__body">' +
          '<div class="cdr__title">' + esc(it.product_title) + '</div>' +
          (meta ? '<div class="cdr__meta">' + esc(meta) + '</div>' : '') +
          (cdrBulletsTpl ? cdrBulletsTpl.innerHTML : '') +
          '<div class="cdr__qty"><div class="cdr__stepper"><button type="button" data-cart-qty="-1" aria-label="Decrease quantity">&minus;</button><span>' + it.quantity + '</span><button type="button" data-cart-qty="1" aria-label="Increase quantity">+</button></div><button type="button" class="cdr__remove" data-cart-remove="' + (i + 1) + '">Remove</button></div>' +
          '<div class="cdr__per">' + money(Math.round(it.final_line_price / (bags * it.quantity))) + ' per bag</div>' +
        '</div></div>';
    }).join('');
    var savings = compareTotal - cart.total_price;
    $$('[data-cart-subtotal]').forEach(function (n) { n.textContent = money(savings > 0 ? compareTotal : cart.total_price); });
    $$('[data-cart-savings]').forEach(function (n) { n.textContent = '-' + money(savings); });
    $$('[data-cart-savings-row]').forEach(function (n) { n.style.display = savings > 0 ? '' : 'none'; });
    $$('[data-cart-total]').forEach(function (n) { n.textContent = money(cart.total_price); });
    var codes = cart.items.map(function (it) { return (cdrVariants[String(it.variant_id)] || {}).code; }).filter(Boolean);
    $$('.cdr__checkout').forEach(function (a) { a.setAttribute('href', '/checkout' + (codes.length ? '?discount=' + encodeURIComponent(codes.join(',')) : '')); });
  }
  function refreshCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {}); }
  function changeLine(line, qty) {
    var drawer = $('#CartDrawer'); drawer && drawer.classList.add('cdr--busy');
    fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) }).then(function (r) { return r.json(); }).then(renderCart).catch(refreshCart);
  }
  document.addEventListener('click', function (e) {
    var r = e.target.closest('[data-cart-remove]'); if (r) { changeLine(Number(r.getAttribute('data-cart-remove')), 0); return; }
    var q = e.target.closest('[data-cart-qty]'); if (!q) return;
    var item = q.closest('[data-line]'); var cur = Number($('.cdr__stepper span', item).textContent) || 1;
    changeLine(Number(item.getAttribute('data-line')), Math.max(0, cur + Number(q.getAttribute('data-cart-qty'))));
  });
  refreshCart();

  /* ---------- countdown (per-visitor timer, like Resilia's: starts just under 2 h, restarts when it ends) ---------- */
  $$('[data-cl-countdown]').forEach(function (bar) {
    var h = $('[data-cd-h]', bar), m = $('[data-cd-m]', bar), s = $('[data-cd-s]', bar);
    var mins = Number(bar.getAttribute('data-minutes') || 120), key = 'cl_countdown_end';
    function endTime() {
      var end = 0; try { end = Number(localStorage.getItem(key)) || 0; } catch (e) {}
      if (!end || end < Date.now()) { end = Date.now() + mins * 60000; try { localStorage.setItem(key, String(end)); } catch (e) {} }
      return end;
    }
    var end = endTime();
    function tick() {
      var d = Math.floor((end - Date.now()) / 1000);
      if (d < 0) { end = endTime(); d = Math.floor((end - Date.now()) / 1000); }
      h.textContent = String(Math.floor(d / 3600)).padStart(2, '0'); m.textContent = String(Math.floor(d % 3600 / 60)).padStart(2, '0'); s.textContent = String(d % 60).padStart(2, '0');
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---------- product selector ---------- */
  function initProductSelector(ps) {
    var sid = ps.getAttribute('data-section-id');
    var boxes = $$('.offer-box', ps);
    var topPrice = $('.price-rows .price', ps), topCompare = $('.price-rows .compare-price', ps), saveAmt = $('[data-save-amount]', ps);
    var pillCompare = $('.atcr-pill .compare-price', ps), pillPrice = $('.atcr-pill .main-price', ps);
    var idInput = $('input[name="id"]', ps);
    var code = ''; /* bundle discount code of the selected offer (Resilia-style: full price + code at checkout) */
    /* choice mode (Leo 2026-10-27, main page): one-time vs subscribe & save; ad pages stay subscription-only */
    var hasToggle = ps.hasAttribute('data-purchase-toggle');
    var mode = hasToggle ? (ps.getAttribute('data-purchase-default') || 'subscription') : (ps.getAttribute('data-selling-plan') ? 'subscription' : 'one_time');
    var opts = $$('.pmt__opt', ps), terms = $('[data-pmt-terms]', ps), termsTpl = terms ? terms.textContent : '';
    var current = null;
    function applyMode() {
      if (!hasToggle) return;
      boxes.forEach(function (b) {
        var sub = mode === 'subscription';
        var pc = b.getAttribute(sub ? 'data-sub-cents' : 'data-ot-cents'), cc = b.getAttribute(sub ? 'data-sub-compare' : 'data-ot-compare');
        b.setAttribute('data-price-cents', pc); b.setAttribute('data-compare-cents', cc);
        var bp = $('[data-box-price]', b), bc = $('[data-box-compare]', b), pb = $('[data-per-bag]', b);
        if (bp) bp.textContent = money(Number(pc));
        if (bc) bc.textContent = Number(cc) > Number(pc) ? money(Number(cc)) : '';
        if (pb) pb.textContent = money(Math.round(Number(pc) / (Number(b.getAttribute('data-bags')) || 1)));
      });
      opts.forEach(function (o) { var on = o.getAttribute('data-pmt') === mode; o.classList.toggle('is-active', on); o.setAttribute('aria-checked', on ? 'true' : 'false'); });
      $$('[data-pmt-subonly]', ps).forEach(function (n) { n.style.display = mode === 'subscription' ? '' : 'none'; });
      if (terms) terms.style.display = mode === 'subscription' ? '' : 'none';
    }
    opts.forEach(function (o) { o.addEventListener('click', function () { mode = o.getAttribute('data-pmt'); applyMode(); if (current) select(current); }); });
    applyMode();
    function select(box) {
      current = box;
      boxes.forEach(function (b) { b.classList.toggle('active', b === box); var r = $('input[type=radio]', b); if (r) r.checked = (b === box); });
      var price = Number(box.getAttribute('data-price-cents')), cmp = Number(box.getAttribute('data-compare-cents'));
      if (terms) terms.textContent = termsTpl.replace('[price]', money(price));
      if (idInput) idInput.value = box.getAttribute('data-variant-id');
      code = box.getAttribute('data-discount-code') || '';
      if (topPrice) topPrice.textContent = money(price);
      if (topCompare) { topCompare.textContent = cmp > price ? money(cmp) : ''; }
      if (saveAmt) saveAmt.textContent = cmp > price ? money(cmp - price) : '';
      if (pillPrice) pillPrice.textContent = money(price);
      if (pillCompare) pillCompare.textContent = cmp > price ? money(cmp) : '';
    }
    boxes.forEach(function (b) { b.addEventListener('click', function () { select(b); }); });
    var def = boxes[Number(ps.getAttribute('data-default-offer') || 1) - 1] || boxes[0];
    if (def) select(def);

    var atc = $('.add-to-cart-button', ps);
    atc && atc.addEventListener('click', function () {
      if (!idInput) return;
      atc.classList.add('loading_hk');
      /* one product: replace the cart so going back and adding again never doubles the order */
      fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).catch(function () {}).then(function () { return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [Object.assign({ id: Number(idInput.value), quantity: 1 }, (ps.getAttribute('data-selling-plan') && mode === 'subscription') ? { selling_plan: Number(ps.getAttribute('data-selling-plan')) } : {})] }) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
; })
        .then(function () { return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: code }) }).catch(function () {}); })
        .then(function () { window.location.href = '/checkout' + (code ? '?discount=' + encodeURIComponent(code) : ''); })
        .catch(function () { atc.classList.remove('loading_hk'); window.location.href = '/cart'; });
    });
    /* Back button restores the page from cache with the button still in its loading state: reset it */
    window.addEventListener('pageshow', function () { atc && atc.classList.remove('loading_hk'); });

    /* delivery date */
    var dt = $('.date-text', ps);
    if (dt && !dt.hasAttribute('data-static')) { var days = Number(ps.getAttribute('data-delivery-days') || 5); var d = new Date(); d.setDate(d.getDate() + days); dt.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }

    /* sold bar animates in */
    var bar = $('.sold-progress-bar', ps);
    if (bar) { var target = bar.style.getPropertyValue('--sold-progress'); bar.style.setProperty('--sold-progress', '0%'); requestAnimationFrame(function () { setTimeout(function () { bar.style.setProperty('--sold-progress', target); }, 100); }); }

    /* accordions */
    $$('.faq-questions', ps).forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('.faq-items'); var open = item.classList.toggle('open');
        var ic = $('.toggle-icons', q); if (ic) ic.textContent = open ? '−' : '+';
      });
    });

    /* gallery */
    whenSwiper(function (Swiper) {
      var thumbsEl = $('.product-swiper-thumbs', ps), mainEl = $('.product-swiper-main', ps);
      var thumbs = thumbsEl ? new Swiper(thumbsEl, { slidesPerView: 5, spaceBetween: 4, watchSlidesProgress: true, slideToClickedSlide: true }) : null;
      if (mainEl) {
        var mainSw = new Swiper(mainEl, { slidesPerView: 1, spaceBetween: 0, loop: true, navigation: { nextEl: $('.swiper-thumb-next', ps), prevEl: $('.swiper-thumb-prev', ps) }, thumbs: thumbs ? { swiper: thumbs } : undefined });
        var pgN = $('.pg-next', ps), pgP = $('.pg-prev', ps);  // Leo 2026-10-23: arrows on the main image, phone and desktop
        if (pgN) pgN.addEventListener('click', function () { mainSw.slideNext(); });
        if (pgP) pgP.addEventListener('click', function () { mainSw.slidePrev(); });
      }
      $$('.oo-vt-block', ps).forEach(function (blk) {
        var vt = $('.oo-vt-swiper', blk); if (!vt) return;
        var mob = blk.classList.contains('oo-vt-block--mob'), n = $$('.oo-vt-slide', vt).length;
        new Swiper(vt, { slidesPerView: mob ? 2 : 3, spaceBetween: mob ? 12 : 16, loop: n > (mob ? 2 : 3), navigation: { prevEl: $('.oo-vt-prev', blk), nextEl: $('.oo-vt-next', blk) } });
      });
    });
  }
  $$('product-selector').forEach(initProductSelector);

  /* ---------- swiper loader ---------- */
  var swiperQueue = [];
  function whenSwiper(fn) { if (window.Swiper) fn(window.Swiper); else swiperQueue.push(fn); }
  (function waitSwiper() { if (window.Swiper) { swiperQueue.splice(0).forEach(function (fn) { fn(window.Swiper); }); } else setTimeout(waitSwiper, 50); })();

  /* ---------- review slider ---------- */
  $$('[data-cl-review-slider]').forEach(function (sec) {
    if (!$('.ts-review-swiper', sec)) return; /* grid layout: no slider */
    whenSwiper(function (Swiper) {
      new Swiper($('.ts-review-swiper', sec), { slidesPerView: 'auto', spaceBetween: 0, loop: true, navigation: { nextEl: $('.ts-next', sec), prevEl: $('.ts-prev', sec) }, pagination: { el: $('.swiper-pagination', sec), clickable: true } }); /* fixed-width cards like Purelia (2026-10-27) */
    });
  });

  /* ---------- 5 reasons ---------- */
  $$('[data-cl-reasons]').forEach(function (sec) {
    whenSwiper(function (Swiper) {
      new Swiper($('.benefits-swiper', sec), { slidesPerView: 1, spaceBetween: 12, loop: true, navigation: { prevEl: $('.benefits-prev', sec), nextEl: $('.benefits-next', sec) }, pagination: { el: $('.swiper-pagination', sec), clickable: true }, breakpoints: { 768: { slidesPerView: 3, spaceBetween: 12 } } });
    });
  });

  /* ---------- video testimonials ---------- */
  $$('[data-cl-video-testimonials]').forEach(function (sec) {
    whenSwiper(function (Swiper) {
      new Swiper($('.swiper', sec), { slidesPerView: 3, slidesPerGroup: 1, spaceBetween: 0, loop: true, pagination: { el: $('.vt-pagination', sec), clickable: true }, navigation: { prevEl: $('.vt-prev', sec), nextEl: $('.vt-next', sec) }, breakpoints: { 768: { slidesPerView: 3 }, 1024: { slidesPerView: 4, slidesPerGroup: 2 }, 1200: { slidesPerView: 6, slidesPerGroup: 2 } } });
    });
  });

  /* ---------- compounds mobile carousel ---------- */
  $$('[data-cl-compounds]').forEach(function (sec) {
    var track = $('.compounds-carousel-track', sec); if (!track) return;
    var slides = $$('.compounds-carousel-slide', track); var i = 0;
    function go(n) { i = (n + slides.length) % slides.length; var w = slides[0].getBoundingClientRect().width + 16; track.style.transform = 'translateX(' + (-i * w) + 'px)'; }
    $('.compounds-nav-prev', sec).addEventListener('click', function () { go(i - 1); });
    $('.compounds-nav-next', sec).addEventListener('click', function () { go(i + 1); });
  });

  /* ---------- stat counters ---------- */
  function animateNumber(el, to, suffix) {
    var start = null, dur = 1500;
    function step(ts) { if (!start) start = ts; var p = Math.min(1, (ts - start) / dur); var v = Math.round(to * (1 - Math.pow(1 - p, 3))); el.textContent = v.toLocaleString('en-US') + suffix; if (p < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  var statObs = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return; statObs.unobserve(en.target);
      var raw = en.target.getAttribute('data-value') || ''; var mt = raw.match(/^([\d,\.]+)(.*)$/);
      if (mt) animateNumber(en.target, Number(mt[1].replace(/,/g, '')), mt[2]); else en.target.textContent = raw;
    });
  }, { threshold: .4 }) : null;
  $$('.stat-percentage[data-value]').forEach(function (el) { if (statObs) statObs.observe(el); else el.textContent = el.getAttribute('data-value'); });

  /* ---------- journey timeline ---------- */
  var msObs = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) en.target.classList.add('active'); });
  }, { threshold: .6 }) : null;
  $$('.milestone-item').forEach(function (m) { if (msObs) msObs.observe(m); else m.classList.add('active'); });

  /* ---------- flip cards ---------- */
  $$('.section3_lp .faq_question').forEach(function (q) { q.addEventListener('click', function () { q.classList.toggle('active'); }); });

  /* ---------- read more reviews ---------- */
  $$('.read-more-btn').forEach(function (b) { b.addEventListener('click', function () { $$('.hidden-review', b.closest('section')).forEach(function (r) { r.classList.add('show'); }); b.style.display = 'none'; }); });

  /* ---------- smooth scroll to buy box ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#scroll-pro"]'); if (!a) return;
    var target = document.getElementById('scroll-pro'); if (!target) return;
    e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();

/* Customer UGC videos: paused until tapped; tap plays with sound (and pauses any other), tap again pauses */
(function () {
  function setState(v) { v.parentNode.classList.toggle('is-playing', !v.paused); }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('video.cl-ugc, .cl-ugc-play'); if (!t) return;
    e.preventDefault();
    var v = t.tagName === 'VIDEO' ? t : t.parentNode.querySelector('video.cl-ugc');
    if (v.paused) {
      document.querySelectorAll('video.cl-ugc').forEach(function (o) { if (o !== v && !o.paused) { o.pause(); setState(o); } });
      v.muted = false; v.play(); v.parentNode.classList.add('is-playing');
    } else { v.pause(); setState(v); }
  });
  document.addEventListener('ended', function (e) { if (e.target.matches && e.target.matches('video.cl-ugc')) { e.target.currentTime = 0; setState(e.target); } }, true);
})();
